export default {
  crm: {
    title: 'CRM',
    dashboard: 'ダッシュボード',
    companies: '企業',
    prospects: '見込み客ファイル',
    contacts: '連絡先',
    interactions: 'やり取り',
    back_to_app: '戻る',

    // Navigation tabs
    tab_dashboard: 'ダッシュボード',
    tab_pipeline: 'パイプライン',
    tab_prospects: '見込み客',
    new_prospect_btn: '+ 新規見込み客',

    // Dashboard stats
    stat_total_prospects: '見込み客の合計',
    stat_active_prospects: 'アクティブな見込み客',
    stat_hot_prospects: '有望な見込み客',
    stat_converted_month: '今月の成約数',
    pipeline_breakdown: 'パイプラインの内訳',
    conversion_stats: 'コンバージョン統計（30日間）',
    conversion_rate: 'コンバージョン率',
    created_30d: '作成',
    converted_30d: '成約',
    avg_delay: '平均所要期間',
    days: '日',
    recent_activity: '最近のアクティビティ',
    view_pipeline: 'パイプラインを見る',

    // Pipeline
    pipeline_title: 'パイプライン',
    pipeline_total_value: '合計金額',
    pipeline_avg_deal: '平均取引額',
    temperature_hot: 'ホット',
    temperature_warm: 'ウォーム',
    temperature_cold: 'コールド',
    score: 'スコア',
    prospect_moved: '見込み客を移動しました',
    no_prospects_in_column: '見込み客なし',

    // Prospect detail
    company_info: '企業情報',
    contact_info: '連絡先',
    score_card: 'スコア',
    opportunities: '商談',
    metadata: 'メタデータ',
    convert_to_exhibitor: '出展者に変換',
    convert_confirm: 'この見込み客を出展者に変換しますか？',
    convert_success: '見込み客を出展者に変換しました',
    convert_only_won: '成約した見込み客のみ変換できます',
    already_converted: 'この見込み客はすでに変換されています',
    back_to_prospects: '見込み客に戻る',

    // Companies
    companies_management: '企業管理',
    company_name: '会社名',
    siret: 'SIRET',
    siren: 'SIREN',
    address: '住所',
    city: '市区町村',
    postal_code: '郵便番号',
    country: '国',
    phone: '電話番号',
    email: 'メールアドレス',
    website: 'ウェブサイト',
    notes: 'メモ',
    new_company: '新規企業',
    edit_company: '企業を編集',
    company_detail: '企業の詳細',
    siret_lookup: 'SIRET検索',
    siret_lookup_placeholder: 'SIRET番号を入力...',
    siret_lookup_btn: '検索',
    siret_not_found: 'このSIRETの企業は見つかりません',
    delete_company_confirm: 'この企業を削除してもよろしいですか？',
    company_created: '企業を作成しました',
    company_updated: '企業を更新しました',
    company_deleted: '企業を削除しました',

    // Contacts
    first_name: '名',
    last_name: '姓',
    position: '役職',
    is_primary: '主要連絡先',
    new_contact: '新規連絡先',
    edit_contact: '連絡先を編集',
    delete_contact_confirm: 'この連絡先を削除してもよろしいですか？',
    contact_created: '連絡先を作成しました',
    contact_updated: '連絡先を更新しました',
    contact_deleted: '連絡先を削除しました',
    no_contacts: '連絡先はまだありません',

    // Prospect Files
    prospect_files: '見込み客ファイル',
    new_prospect: '新規見込み客ファイル',
    edit_prospect: '見込み客ファイルを編集',
    prospect_detail: '見込み客の詳細',
    status: 'ステータス',
    priority: '優先度',
    source: '情報源',
    estimated_surface: '想定面積 (m²)',
    estimated_budget: '想定予算',
    select_event: 'イベントを選択',
    select_company: '企業を選択',
    select_contact: '連絡先を選択',
    delete_prospect_confirm: 'この見込み客ファイルを削除してもよろしいですか？',
    prospect_created: '見込み客ファイルを作成しました',
    prospect_updated: '見込み客ファイルを更新しました',
    prospect_deleted: '見込み客ファイルを削除しました',
    no_prospects: '見込み客ファイルはまだありません',

    // Statuses
    status_new: '新規',
    status_contacted: '連絡済み',
    status_qualified: '有望',
    status_proposal: '提案',
    status_negotiation: '交渉',
    status_won: '成約',
    status_lost: '失注',

    // Priorities
    priority_low: '低',
    priority_medium: '中',
    priority_high: '高',

    // Interactions
    interaction_type: 'タイプ',
    subject: '件名',
    content: '内容',
    interaction_date: '日付',
    new_interaction: '新規やり取り',
    delete_interaction_confirm: 'このやり取りを削除してもよろしいですか？',
    interaction_created: 'やり取りを作成しました',
    interaction_deleted: 'やり取りを削除しました',
    no_interactions: 'やり取りはまだありません',

    // Interaction types
    type_call: '電話',
    type_email: 'メール',
    type_meeting: '会議',
    type_note: 'メモ',
    type_other: 'その他',

    // Common
    search_placeholder: '検索...',
    no_results: '結果が見つかりません',
    back: '戻る',
    save: '保存',
    cancel: 'キャンセル',
    delete: '削除',
    confirm: '確認',
    actions: '操作',
    created_at: '作成日',
    updated_at: '更新日',
  },
};
